import { render, staticRenderFns } from "./receiveDetail.vue?vue&type=template&id=cbce91a2&scoped=true"
import script from "./receiveDetail.vue?vue&type=script&lang=js"
export * from "./receiveDetail.vue?vue&type=script&lang=js"
import style0 from "./receiveDetail.vue?vue&type=style&index=0&id=cbce91a2&prod&lang=scss"
import style1 from "./receiveDetail.vue?vue&type=style&index=1&id=cbce91a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbce91a2",
  null
  
)

export default component.exports